/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCheckboxReadOnly/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaCheckboxReadOnly({
  children,
  viewPath = "/DesignSystem/TysiaCheckboxReadOnly",
  value
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text={value ? "✓" : "✗"}
/>
{children}
</React.Fragment>)
}